const EDIT_MATCH = 'EDIT_MATCH'
const STOP_EDIT_MATCH = 'STOP_EDIT_MATCH'

export const editMatchId = (state = null, action) => {
    switch (action.type) {
        case EDIT_MATCH:
            return action.game_id

        case STOP_EDIT_MATCH:
            return null

        default:
            return state
    }
}


// actions

export const editMatch = (game_id) => {
    return { type: EDIT_MATCH, game_id }
}

export const stopEditMatch = () => {
    return { type: STOP_EDIT_MATCH }
}


// WEBPACK FOOTER //
// ./src/reducers/editMatchId/index.js